var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5.43506C2.25 4.63941 2.56607 3.87635 3.12868 3.31374C3.69129 2.75113 4.45435 2.43506 5.25 2.43506H18.75C19.5456 2.43506 20.3087 2.75113 20.8713 3.31374C21.4339 3.87635 21.75 4.63941 21.75 5.43506V15.1851C21.75 15.9807 21.4339 16.7438 20.8713 17.3064C20.3087 17.869 19.5456 18.1851 18.75 18.1851H15.75V18.4421C15.75 19.0391 15.987 19.6121 16.409 20.0331L17.03 20.6551C17.1348 20.7599 17.2061 20.8935 17.235 21.0389C17.2638 21.1843 17.249 21.335 17.1923 21.472C17.1356 21.6089 17.0395 21.726 16.9163 21.8085C16.7931 21.8909 16.6482 21.9349 16.5 21.9351H7.5C7.35176 21.9349 7.20688 21.8909 7.08367 21.8085C6.96045 21.726 6.86442 21.6089 6.80771 21.472C6.751 21.335 6.73615 21.1843 6.76503 21.0389C6.79392 20.8935 6.86524 20.7599 6.97 20.6551L7.591 20.0331C8.01271 19.6113 8.24974 19.0394 8.25 18.4431V18.1851H5.25C4.45435 18.1851 3.69129 17.869 3.12868 17.3064C2.56607 16.7438 2.25 15.9807 2.25 15.1851V5.43506ZM3.75 5.43506V12.9351C3.75 13.3329 3.90804 13.7144 4.18934 13.9957C4.47064 14.277 4.85218 14.4351 5.25 14.4351H18.75C19.1478 14.4351 19.5294 14.277 19.8107 13.9957C20.092 13.7144 20.25 13.3329 20.25 12.9351V5.43506C20.25 5.03723 20.092 4.6557 19.8107 4.3744C19.5294 4.09309 19.1478 3.93506 18.75 3.93506H5.25C4.85218 3.93506 4.47064 4.09309 4.18934 4.3744C3.90804 4.6557 3.75 5.03723 3.75 5.43506Z",
    fill: "#0A122A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.c54b71189b8aadc13f52e847b7c48ae6.svg";
export { ForwardRef as ReactComponent };